import { Component, OnInit } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CustomDateParserFormatter } from '../shared/adapters/datepicker-adapter';
import { tagReport } from './shared/models/tag-report.model';
import { TagReportService } from './shared/services/tag-report.service';

@Component({
  selector: 'app-tag-report',
  templateUrl: './tag-report.component.html',
  styleUrls: ['./tag-report.component.css'],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]
})
export class TagReportComponent implements OnInit {

  tagReportSearchCriteria: tagReport;
  DateFrom: NgbDateStruct;
  DateTo: NgbDateStruct;
  tagReport: any;
  paraNoRec: boolean = true;
  maxDate: NgbDateStruct;


  constructor(private _modalSvc: NgbModal, private _tagSvc: TagReportService, private _toasterSvc: ToastrService) { }

  ngOnInit() {
    this.resetForm();
    const current = new Date();
    this.maxDate = { year: current.getFullYear(), month: current.getMonth() + 1, day: current.getDate() };
  }

  resetForm() {
    let from = new Date();
    let to = new Date();
    from.setDate(from.getDate() - 7);
    this.DateFrom = { year: from.getFullYear(), month: from.getMonth() + 1, day: from.getDate() }
    this.DateTo = { year: to.getFullYear(), month: to.getMonth() + 1, day: to.getDate() },
      this.tagReportSearchCriteria = {
        DateFrom: (from.getMonth() + 1) + '/' + from.getDate() + '/' + from.getFullYear(),
        DateTo: (to.getMonth() + 1) + '/' + to.getDate() + '/' + to.getFullYear(),
        FranchiseId: 0,
        PageNo: 1,
        PageSize: 10,
        LotNumber: null
      };

  }

  searchTagRpt(PageNo: number) {

    this.tagReportSearchCriteria.DateFrom = this.DateFrom.month + '/' + this.DateFrom.day + '/' + this.DateFrom.year;
    this.tagReportSearchCriteria.DateTo = this.DateTo.month + '/' + this.DateTo.day + '/' + this.DateTo.year;
    this._tagSvc.getTagReport(this.tagReportSearchCriteria).subscribe(response => {
      if (response.ResultMessages.length > 0) {
        response.ResultMessages.forEach((res: any) => {
          this._toasterSvc.warning(res.Message);
          this.tagReport = null;
        });
      }
      else {
        this._toasterSvc.success("New Records");
        this.tagReport = response;
        if (response?.LotTaggingRpt?.length > 0) {
          this.paraNoRec = false;
        }
        console.log(response);
      }

    });
  }
  cancelSearch() {
    this.ngOnInit();
    this.tagReport = null;
    this.paraNoRec = true;
  }
}
